  import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { DomainConfigComponent } from "@app/domain-config.component";
import {
  PORTAL_CHAT_COUNTERPARTY,
  PORTAL_CHAT_LEGACY,
} from "@app/shared/portal-chat/portal-chat.constants";

@Injectable({
  providedIn: "root",
})
export class RequirementService {
  justCreated: boolean = false;

  constructor(
      private http: HttpClient,
      private domainConfigComponent: DomainConfigComponent) {}

  private portalCommentsPath(requirementId: number): string {
    const profile = this.domainConfigComponent.isPortalChatCounterparty()
      ? PORTAL_CHAT_COUNTERPARTY
      : PORTAL_CHAT_LEGACY;
    return `${environment.apiUrl}${profile.trackvisionCommentsPath(requirementId)}`;
  }

  getRequirementTemplates(requirementId) {
    return this.http.get(
      `${environment.apiUrl}/trackvision/requirement/get/${requirementId}/templates`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  getRequirementFieldsDetail(requirementId) {
    return this.http.get(
      `${environment.apiUrl}/trackvision/requirement/get/${requirementId}/fields`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  // retrieving all data requirementsm, into  main table
  getRequirement(body): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/list/getdata`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  // search requirements by requirementtype
  searchRequirements(body): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/list/search`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  // retrieving all data requirementsm, into  main table
  getRequirementsGetData(body): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/list/getdatav2`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  // retrieving  just one requirement's data
  getRequirementAllData(requirementId) {
    return this.http.get(
      `${environment.apiUrl}/trackvision/requirement/get/${requirementId}`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  getAttachments(documentId) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/attachment/list`,
      {
        id: documentId,
      },
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  getRequirementHeaders(requirementId) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/list/getheaders`,
      {
        id: requirementId,
      },
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  createFieldTrackvision(table: string, body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/crud/create/${table}`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  createActivityAlertTrackvision(body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/activityalert/create`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  // edit Activity
  editActivityAlertTrackvision(body: any) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/activityalert/edit`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  getAllActvAlerts(requirementId) {
    return this.http.get(
      `${environment.apiUrl}/trackvision/requirement/activityalert/list/${requirementId}`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  async completedActivity(body: any):Promise<any> {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/activityalert/completed`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    ).toPromise();
  }

  uploadOneFile(formData,path): Observable<Object> {
    return this.http.post(
      `${environment.apiUrl}/${path}/attachment/upload`,
      formData,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  createSignature(data): Observable<Object> {
    return this.http.post(
      `${environment.apiUrl}/trackvision/signature`,
      data,
      {
        headers: new HttpHeaders().set(
          'Token',
          localStorage.getItem('access_token') || ''
        ),
      }
    );
  }

  /**
   * Envía todos los documentos en una sola llamada a TuFirma (transactions-batch).
   * Payload: name, external_reference, reference, documents: [{ attachmentId, name }], signingparties, signatureType, createdBy.
   */
  createSignatureBatch(data): Observable<Object> {
    return this.http.post(
      `${environment.apiUrl}/trackvision/signature/transactions-batch`,
      data,
      {
        headers: new HttpHeaders().set(
          'Token',
          localStorage.getItem('access_token') || ''
        ),
      }
    );
  }

  uploadMultipleFiles(body): Observable<Object> {
    const formData: FormData = new FormData();
    for (let i = 0; i < body.length; i++) {
      formData.append(
        `files[${i}]`,
        body[i].attachments,
        body[i].attachments.name
      );
      formData.append(`notes[${i}]`, body[i].note);
    }
    formData.append("length", JSON.stringify(body.length));
    formData.append("requirementid", body[0].requirementid);
    return this.http.post(
      `${environment.apiUrl}/trackvision/attachment/uploadMultipleTemp`,
      formData,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  geDataById(table: string, id: number) {
    return this.http.get(
      `${environment.apiUrl}/common/crud/get/${table}/${id}`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  createNote(body,path) {
    return this.http.post(
      `${environment.apiUrl}/${path}`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  editNote(body,path) {
    return this.http.post(
      `${environment.apiUrl}/${path}`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  getNote(reqId: number) {
    return this.http.get(
      `${environment.apiUrl}/trackvision/requirement/getnote/${reqId}`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  geNoteById(path: string) {
    return this.http.get(
      `${environment.apiUrl}/${path}`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  getSignatures(path: string) {
    return this.http.get(
      `${environment.apiUrl}/${path}`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  deleteNote(idNote, path) {
    return this.http.post(
      `${environment.apiUrl}/${path}`,
      {
        id: idNote,
      },
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  deleteRequirement(requirementId, path) {
    return this.http.post(
      `${environment.apiUrl}/${path}`,
      {
        id: requirementId,
      },
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  createAnswerNote(body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/note/answer`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  // creater calendar activity
  createActivityCalendar(body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/activityalert/create`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  // validation to activity alert
  validationActvAlert(body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/activityAlert/validationActv`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  // get a list of all activities
  getAllActivitiesCalendar(requirementId) {
    return this.http.get(
      `${environment.apiUrl}/trackvision/requirement/calendar/list/${requirementId}`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  deleteAlert(idAlert) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/activityalert/delete`,
      {
        id: idAlert,
      },
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  // edit Alert
  editAlert(id: number, body: any) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/activityAlert/editAlert/${id}`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  deleteActivity(idActv) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/activityAlert/deleteActv`,
      {
        id: idActv,
      },
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  getByType(id: number) {
    return this.http.get(
      `${environment.apiUrl}/trackvision/requirement/list/getByType/${id}`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  assignLawyer(body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/assignLawyer`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token")
        ),
      }
    );
  }

  takeRequirement(body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/take`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token")
        ),
      }
    );
  }

  returnRequirement(body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/return`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token")
        ),
      }
    );
  }

  // edit Activity
  editActivity(body: any) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/activityAlert/editActv`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  // get Activity
  geActivityById(reqId: number, idActv: number) {
    return this.http.get(
      `${environment.apiUrl}/trackvision/requirement/activityalert/show/${idActv}/requirement/${reqId}`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  editReminder(id: number, reqId: number, actvId: number, body: any) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/activityAlert/set/requirement/${reqId}/activity/${actvId}/reminder/${id}`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  createRequirement(body: any) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/create`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  updateRequirement(body: any) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/update`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  changeStatus(body: any) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/update-status`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  addIntoReqFields(body: any) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/requirementField/add`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  getReqFieldsInfo(fields, reqId: number) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/requirementField/isReqFields`,
      {
        fields: fields,
        reqId: reqId,
      },
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  getDataReqFields(customfieldId, reqId) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/requirementField/get`,
      {
        customfieldid: customfieldId,
        reqId: reqId,
      },
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  updateIntoReqFieldsJson(body: any) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/requirementField/update`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  // validation to activity alert
  validationEditActvAlert(body) {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/activityAlert/validationEditActv`,
      body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
  getAllCollaboratorsData(){
    return this.http.get(
      `${environment.apiUrl}/trackvision/requirement/activityalert/getcollaborator`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  integrationFlowServices(data): Observable<Object> {
    return this.http.post(
      `${environment.apiUrl}/trackvision/requirement/integration`,
      data,
      {
        headers: new HttpHeaders().set(
          'Token',
          localStorage.getItem('access_token') || ''
        ),
      }
    );
  }

  getEmailHistory(reqId: number) {
    return this.http.get(
      `${environment.apiUrl}/trackvision/requirement/getemailhistory/${reqId}`,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  getPortalclientComments(requirementId: number): Observable<any> {
    return this.http.get(
      this.portalCommentsPath(requirementId),
      {
        headers: new HttpHeaders().set(
          'Token',
          localStorage.getItem('access_token') || ''
        ),
      }
    );
  }

  getPortalContactEmailStatus(requirementId: number): Observable<{
    mode?: string;
    hasContactEmail?: boolean;
    hasLinkedContact?: boolean;
    warningMessage?: string | null;
    adminContactPath?: string | null;
    adminContactLinkLabel?: string | null;
  }> {
    return this.http.get(
      `${environment.apiUrl}/trackvision/requirement/${requirementId}/portal-contact-email`,
      {
        headers: new HttpHeaders().set(
          'Token',
          localStorage.getItem('access_token') || ''
        ),
      }
    );
  }

  /** Envía un mensaje al contacto externo (legado o contrapartes según dominio). */
  addPortalclientComment(requirementId: number, note: string, file?: File | null): Observable<any> {
    const token = localStorage.getItem('access_token') || '';
    const formData = new FormData();
    formData.append('note', note);
    if (file && file.name) formData.append('file', file, file.name);
    return this.http.post(
      this.portalCommentsPath(requirementId),
      formData,
      { headers: new HttpHeaders().set('Token', token) }
    );
  }

  /** Marca como leídos los mensajes del contacto externo (visto por el owner). */
  markPortalclientCommentsRead(requirementId: number): Observable<any> {
    return this.http.patch(
      `${this.portalCommentsPath(requirementId)}/read`,
      {},
      { headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') }
    );
  }

  generateIADocument(Id: number) {
    return this.http.post(
      `${environment.apiUrl}/common/ai/reports`,
      {'id':Id},
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }

  massiveUpload(requirementTypeId: number, flowName: string, file: File): Observable<any> {
    return new Observable(observer => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result as string;
        // Remover el prefijo data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,
        const base64Data = base64.split(',')[1] || base64;

        const payload = {
          requirementTypeId: requirementTypeId,
          flowName: flowName,
          file: base64Data
        };

        this.http.post(
          `${environment.apiUrl}/trackvision/requirement/massive-upload`,
          payload,
          {
            headers: new HttpHeaders().set(
              "Token",
              localStorage.getItem("access_token") || ""
            ),
          }
        ).subscribe({
          next: (response) => observer.next(response),
          error: (error) => observer.error(error),
          complete: () => observer.complete()
        });
      };
      reader.onerror = (error) => observer.error(error);
      reader.readAsDataURL(file);
    });
  }

  /**
  /**
   * Previsualiza una imagen/PDF: el backend la lee (OCR+IA) y devuelve los campos extraídos,
   * la confianza y el flujo destino, SIN crear el requerimiento. Devuelve también un storageId
   * para reusar al confirmar (no se relee la imagen). El Token de auth lo agrega TokenInterceptor.
   */
  previewImageIntake(file: File): Observable<any> {
    return new Observable(observer => {
      const reader = new FileReader();
      reader.onload = () => {
        const dataUrl = reader.result as string;
        const base64Data = dataUrl.split(',')[1] || dataUrl;
        const mime = (dataUrl.match(/^data:(.*?);base64/) || [])[1] || file.type || 'image/jpeg';
        const payload = { base64: base64Data, mime, filename: file.name };

        this.http.post(
          `${environment.apiUrl}/trackvision/imageintake/preview`,
          payload
        ).subscribe({
          next: (r) => observer.next(r),
          error: (e) => observer.error(e),
          complete: () => observer.complete()
        });
      };
      reader.onerror = (error) => observer.error(error);
      reader.readAsDataURL(file);
    });
  }

  /**
   * Confirma la creación tras la previsualización: crea el requerimiento con los campos ya
   * revisados/corregidos por el usuario y la imagen ya en storage (no se relee).
   */
  confirmImageIntake(params: {
    temporaryFileId: number;
    filename?: string;
    typeId: number;
    fields: Array<{ customfieldId: number; value: any }>;
    caption?: string;
  }): Observable<any> {
    const payload: any = {
      // messageId idempotente: derivado del temporaryFileId (estable por previsualización). Si el
      // usuario reintenta "Crear" tras un timeout donde el backend ya creó, el mismo id permite
      // deduplicar y evitar un requerimiento/adjunto duplicado del mismo documento.
      messageId: `ui-img-${params.temporaryFileId}`,
      temporaryFileId: params.temporaryFileId,
      filename: params.filename,
      typeId: params.typeId,
      fields: params.fields,
      from: 'ui'
    };
    if (params.caption) { payload.caption = params.caption; }
    return this.http.post(
      `${environment.apiUrl}/trackvision/imageintake/process`,
      payload
    );
  }


}
